import React from 'react';

const ReportSelector = React.memo(({ reportType, setReportType }) => {
  return (
    <div style={{ marginBottom: '16px' }}>
      <h3 style={{ margin: '0 0 8px 0' }}>Report Type</h3>
      <div>
      <label style={{ display: 'inline-flex', alignItems: 'center' }}>
          <input
            type="radio"
            name="reportType"
            value="questionCount"
            checked={reportType === 'questionCount'}
            onChange={(e) => setReportType(e.target.value)}
            style={{ marginRight: '8px' }}
          />
          Question Count
        </label>
        <label style={{ marginRight: '16px', display: 'inline-flex', alignItems: 'center' }}>
          <input
            type="radio"
            name="reportType"
            value="topicStats"
            checked={reportType === 'topicStats'}
            onChange={(e) => setReportType(e.target.value)}
            style={{ marginRight: '8px' }}
          />
          Topic Stats
        </label>
       
      </div>
    </div>
  );
});

export default ReportSelector;
